/** @format — Authenticated playback for persisted live/voice-note audio */

import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../config";
import { getToken } from "../../utils/tokenStorage";

export default function VoiceMessagePlayer({ chatId, messageId, metadata }) {
  const voiceNote = metadata?.voice_note;
  const token = getToken();
  const [audioUrl, setAudioUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(
    () => () => {
      if (audioUrl) URL.revokeObjectURL(audioUrl);
    },
    [audioUrl],
  );

  if (!voiceNote || !token || !chatId || !messageId) return null;

  const loadAudio = async () => {
    if (audioUrl || loading) return;
    setLoading(true);
    setError("");
    try {
      const response = await fetch(
        `${API_BASE_URL}/v1/chats/${encodeURIComponent(chatId)}/messages/${encodeURIComponent(messageId)}/voice`,
        {
          headers: {
            Authorization: token.startsWith("Bearer ") ? token : `Bearer ${token}`,
          },
        },
      );
      if (!response.ok) {
        throw new Error(
          response.status === 404
            ? "This recording is no longer available."
            : "Could not load this recording.",
        );
      }
      setAudioUrl(URL.createObjectURL(await response.blob()));
    } catch (loadError) {
      setError(loadError instanceof Error ? loadError.message : "Could not load this recording.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-2 min-w-[220px]">
      {audioUrl ? (
        <audio className="h-9 w-full max-w-[280px]" controls preload="metadata" src={audioUrl}>
          Your browser does not support audio playback.
        </audio>
      ) : (
        <button
          type="button"
          onClick={loadAudio}
          disabled={loading}
          className="rounded-full border border-neutral-300 bg-white px-3 py-1.5 text-xs font-medium text-neutral-700 hover:bg-neutral-50 disabled:opacity-60"
        >
          {loading ? "Loading voice…" : "Play voice"}
        </button>
      )}
      {error ? <p className="mt-1 text-xs text-red-600">{error}</p> : null}
    </div>
  );
}
